import { useState } from 'react';
import { X, ZoomIn } from 'lucide-react';

/**
 * Náhled aplikace (skutečný screenshot) v rámu okna — kliknutím se zvětší
 * do celoobrazovkového náhledu (Esc / klik mimo zavírá). Používá landing
 * i stránka Funkce.
 */
export function NahledAplikace({
  src,
  alt,
  prioritni = false,
}: {
  src: string;
  alt: string;
  /** Hero obrázek nad ohybem (LCP) — načíst hned, ne lazy. */
  prioritni?: boolean;
}) {
  const [zvetseno, setZvetseno] = useState(false);
  return (
    <>
      <button
        type="button"
        className="group block w-full cursor-zoom-in overflow-hidden rounded-xl border border-border bg-surface text-left shadow-lg"
        onClick={() => setZvetseno(true)}
        aria-label={`Zvětšit náhled: ${alt}`}
      >
        <span className="flex items-center justify-between border-b border-border bg-bg px-3 py-2">
          <span className="flex items-center gap-1.5">
            <span className="size-2.5 rounded-full bg-border-strong" aria-hidden="true" />
            <span className="size-2.5 rounded-full bg-border-strong" aria-hidden="true" />
            <span className="size-2.5 rounded-full bg-border-strong" aria-hidden="true" />
          </span>
          <span className="flex items-center gap-1 text-xs font-semibold text-text-secondary opacity-0 transition-opacity duration-100 group-hover:opacity-100">
            <ZoomIn size={13} strokeWidth={2} aria-hidden="true" /> zvětšit
          </span>
        </span>
        {/* Prioritu stahování hero obrázku řeší <link rel="preload"> v hlavičce
            (React 18 fetchPriority na <img> nezná). */}
        <img src={src} alt={alt} loading={prioritni ? 'eager' : 'lazy'} className="block w-full" />
      </button>

      {zvetseno && (
        <div
          role="dialog"
          aria-modal="true"
          aria-label={alt}
          className="fixed inset-0 z-50 flex flex-col items-center justify-center gap-3 bg-text-heading/90 p-4 lg:p-10"
          onClick={() => setZvetseno(false)}
          onKeyDown={(e) => e.key === 'Escape' && setZvetseno(false)}
        >
          <button
            type="button"
            aria-label="Zavřít náhled"
            className="absolute top-4 right-4 flex size-11 items-center justify-center rounded-full bg-white/15 text-white hover:bg-white/25"
            onClick={() => setZvetseno(false)}
          >
            <X size={22} strokeWidth={2} aria-hidden="true" />
          </button>
          <img
            src={src}
            alt={alt}
            className="max-h-[85vh] max-w-full rounded-lg object-contain shadow-2xl"
            onClick={(e) => e.stopPropagation()}
          />
          <p className="max-w-2xl text-center text-sm text-white/85">{alt}</p>
        </div>
      )}
    </>
  );
}
